import React from 'react';

import PropTypes from 'prop-types';

import { Table } from 'antd';

import { BoxTable } from './style';

import columnGeneral from './collumns/general';

const GridResult = ({ fileData }) => {
  return (
    <BoxTable>
      <div className="BoxAuthContainer">
        <Table
          dataSource={[fileData]}
          columns={columnGeneral}
          pagination={false}
          scroll={{ x: 1200 }}
          onRow={record => ({ rowKey: record.id })}
        />
      </div>
    </BoxTable>
  );
};

GridResult.propTypes = {
  fileData: PropTypes.shape,
};
GridResult.defaultProps = {
  fileData: null,
};

export default GridResult;
